import React, { FC, ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
  id: string;
  children: (eventHandlers: { attributes: any; listeners: any }) => ReactNode;
}
export const SortableItem: FC<Props> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style as any}>
      {children({ attributes, listeners })}
    </div>
  );
};
